"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FIELD;
(function (FIELD) {
    FIELD["MODEL"] = "model";
    FIELD["MODELID"] = "modelId";
    FIELD["MODELS"] = "models";
    FIELD["TYPEID"] = "typeId";
    FIELD["OBJECTID"] = "objectId";
    FIELD["TYPE"] = "type";
    FIELD["VERSION"] = "version";
    FIELD["NAME"] = "name";
    FIELD["TAGS"] = "tags";
    FIELD["ISEXTENSIBLE"] = "isExtensible";
    FIELD["ISMANDATORY"] = "isMandatory";
    FIELD["LINK"] = "link";
    FIELD["VALUE"] = "value";
    FIELD["DATATYPE"] = "dataType";
    FIELD["DESCRIPTION"] = "description";
    FIELD["ITEMS"] = "items";
    FIELD["ENDPOINT"] = "endpoint";
    FIELD["ENUM"] = "enum";
    FIELD["PROPERTIES"] = "properties";
    FIELD["INPUT"] = "input";
    FIELD["INPUTS"] = "inputs";
    FIELD["OUTPUT"] = "output";
    FIELD["OUTPUTS"] = "outputs";
    FIELD["CONDITIONS"] = "conditions";
    FIELD["CONDITION"] = "condition";
    FIELD["SUBCONDITIONS"] = "subConditions";
    FIELD["SUBCONDITION"] = "subCondition";
    FIELD["SEVERITY"] = "severity";
    FIELD["POSSIBLECAUSE"] = "possibleCause";
    FIELD["SUGGESTEDACTION"] = "suggestedAction";
    FIELD["CORRECTIVEACTION"] = "correctiveAction";
    FIELD["LOGIC"] = "logic";
    FIELD["STORAGE"] = "storage";
    FIELD["FUNCTIONS"] = "functions";
    FIELD["FUNCTIONTYPE"] = "functionType";
    FIELD["TRIGGERS"] = "triggers";
    FIELD["TIME"] = "time";
    FIELD["VARIABLECHANGE"] = "variableChange";
    FIELD["ALARMTRIGGER"] = "alarm";
    FIELD["EVENTTRIGGER"] = "event";
    FIELD["INHIBIT"] = "inhibit";
    FIELD["REFERENCEVALUE"] = "referenceValue";
    FIELD["ACTUALVALUE"] = "actualValue";
    FIELD["ATTRIBUTES"] = "attributes";
    FIELD["VARIABLES"] = "variables";
    FIELD["STATUS"] = "status";
    FIELD["CONTENT"] = "content";
    FIELD["STATE"] = "state";
    FIELD["DEVICETYPE"] = "deviceType";
    FIELD["SCEENGGMODELS"] = "sceEngModels";
    FIELD["PATH"] = "path";
    FIELD["LASTMODIFIED"] = "lastModified";
    FIELD["TIMEWINDOW"] = "timeWindow";
    FIELD["SAMPLINGWINDOW"] = "samplingWindow";
    FIELD["SAMPLINGAGGREGATE"] = "samplingAggregate";
    FIELD["LIMIT"] = "limit";
    FIELD["OBJECTTYPES"] = "objectTypes";
    FIELD["SUPPORTEDMODELS"] = "supportedModels";
    FIELD["ENDPOINTURLS"] = "endpointurls";
    FIELD["ISDELETED"] = "isDeleted";
    FIELD["ALARMMAPPING"] = "alarmMapping";
    FIELD["ALARMTYPE"] = "alarmType";
    FIELD["ALARMS"] = "alarms";
    FIELD["OBJECTLINK"] = "objectLink";
    FIELD["ASSETMONITORMODELID"] = "assetMonitorModelId";
    FIELD["TENANTID"] = "tenantId";
    FIELD["TENANT"] = "Tenant";
    FIELD["ID"] = "Id";
    FIELD["SOURCE"] = "Source";
    FIELD["ISDIRTY"] = "isDirty";
    FIELD["COMPONENTS"] = "components";
})(FIELD = exports.FIELD || (exports.FIELD = {}));
//# sourceMappingURL=Field.js.map